module.exports = {
      id: "comm-vikatan-plus-usage",
      viewBox: "0 0 484.569 52.881",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-vikatan-plus",
      toString: function () {
        return this.url;
      }
    }